import {EntityState} from '@ngrx/entity';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {TrackMix} from '@spout/any-shared/models';

export type TrackMixState = EntityState<TrackMix>;
